<template>
  <div class="orderList">
    <Table
      rowKey="orderId"
      :dataSource="list"
      :columns="column"
      :pagination="false"
    >
      <span slot="spNum" slot-scope="text">
        {{ disable ? (0 >= text - num ? 0 : text - num) : text }}
      </span>
      <span slot="useTime" slot-scope="text, record">
        {{ $dateFormat(record.useStartTime) }}至{{
          $dateFormat(record.useEndTime)
        }}
      </span>
      <span slot="action" slot-scope="text, record">
        <Button class="action" @click="checkStatus(record)" :disabled="disable"
          >核销</Button
        >
      </span>
    </Table>
    <Modal
      class="barcode-modal"
      :visible="visible"
      :title="`订单号${record.orderId}`"
      okText="确认"
      :width="400"
      :maskClosable="false"
      @cancel="setVisible(false)"
      @ok="doSubmit"
    >
      <Form :form="form" v-bind="formItemLayout">
        <FormItem label="剩余核销码数">
          <span>{{ record.spNum }}</span>
        </FormItem>
        <FormItem label="核销次数">
          <InputNumber
            placeholder="请输入核销次数"
            :precision="0"
            v-decorator="[
              'num',
              {
                rules: [
                  { required: true, message: '请输入核销次数' },
                  {
                    validator: function(rule, value, callback) {
                      if (value > record.spNum) {
                        callback('核销次数应不大于剩余码数');
                      } else if (value === 0) {
                        callback('请输入正确的核销次数');
                      } else {
                        callback();
                      }
                    }
                  }
                ]
              }
            ]"
          />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
import {
  Table,
  Modal,
  Form,
  InputNumber,
  Button,
  message,
  notification
} from "ant-design-vue";
import { dateFormat } from "@/utils/utils";
import { confirmConsumer4Yuer } from "../services";
import { MIN_SAFE_INTEGER } from '../constants';

export default {
  data() {
    return {
      column: [
        {
          title: "订单号",
          dataIndex: "orderId",
          key: "orderId",
          align: "center"
        },
        {
          title: "商品名称",
          dataIndex: "spuName",
          key: "spuName",
          align: "center"
        },
        {
          title: '商品规格',
          dataIndex: 'skuName',
          key: 'skuName',
          align: 'center'
        },
        {
          title: "核销码总数",
          dataIndex: "sumNum",
          key: "sumNum",
          align: "center"
        },
        {
          title: "剩余核销码数",
          dataIndex: "spNum",
          key: "spNum",
          align: "center",
          scopedSlots: { customRender: "spNum" }
        },
        {
          title: "购买份数",
          dataIndex: "skuNum",
          key: "skuNum",
          align: "center"
        },
        {
          title: "下单手机号",
          dataIndex: "userMobile",
          key: "userMobile",
          align: "center"
        },
        {
          title: "有效期",
          dataIndex: "useTime",
          key: "useTime",
          width: 330,
          align: "center",
          scopedSlots: { customRender: "useTime" }
        },
        {
          title: "操作",
          dataIndex: "action",
          key: "action",
          align: "center",
          scopedSlots: { customRender: "action" }
        }
      ],
      form: Form.createForm(this, { name: "barcode-form" }),
      visible: false,
      record: {},
      formItemLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 }
      },
      disable: false,
      num: 0
    };
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    code: {
      type: String,
      default: ""
    },
    storeInfo: {
      type: Object,
      default: () => {}
    },
    useStore: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    doSubmit() {
      // console.log(this.form)
      this.form.validateFields((err, values) => {
        if (err) {
          return;
        }
        this.num = values.num;
        // console.log('Received values of form: ', values);
        this.confirmConsumer(values.num);
      });
    },
    $dateFormat(time) {
      return dateFormat(time);
    },
    checkStatus(record) {
      this.record = record;
      if (record.spNum === 1) {
        this.confirmConsumer();
      } else {
        this.setVisible(true);
      }
    },
    setVisible(flag) {
      this.visible = flag;
    },
    async confirmConsumer(num = 1) {
      let json;
      if (this.useStore) {
        let { storeId: storeCode } = this.storeInfo;
        // 无门店的情况下，无门店ID不传递至后台
        if (storeCode === MIN_SAFE_INTEGER) {
          storeCode = "";
        }

        json = await confirmConsumer4Yuer({
          code: this.code,
          writeoffNum: num,
          storeCode
        });
      } else {
        json = await this.$store.dispatch("dfwHome/confirmConsumer", {
          code: this.code,
          bid: this.$cookie.get("buzzId"),
          writeoffNum: num
        });
      }

      if (json && json.code * 1 === 1) {
        message.success("核销成功", 2, () => {
          this.visible = false;
          this.disable = true;
        });
      } else {
        notification.error({
          message: "提示",
          description: json.msg,
          duration: 0
        });
      }
    },
    handleSubmit() {}
  },
  components: {
    Table,
    Modal,
    Form,
    FormItem: Form.Item,
    InputNumber,
    Button
  }
};
</script>
<style lang="less">
.orderList {
  margin-top: 20px;

  .action {
    color: #1c7ae5;
    cursor: pointer;
  }
  .ant-btn-disabled,
  .ant-btn.disabled,
  .ant-btn[disabled],
  .ant-btn-disabled:hover,
  .ant-btn.disabled:hover,
  .ant-btn[disabled]:hover,
  .ant-btn-disabled:focus,
  .ant-btn.disabled:focus,
  .ant-btn[disabled]:focus,
  .ant-btn-disabled:active,
  .ant-btn.disabled:active,
  .ant-btn[disabled]:active,
  .ant-btn-disabled.active,
  .ant-btn.disabled.active,
  .ant-btn[disabled].active {
    color: rgba(0, 0, 0, 0.25);
  }
}
.barcode-modal {
  .ant-input-number {
    width: 150px !important;
  }
}
</style>
